export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";